import React, { useState } from 'react';

import { UseMutateFunction, useMutation, useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { Scenario } from 'types/pricingSimulator';
import { pricingSimulatorUrls } from 'config/urls';
import { sendNotification } from 'utils/helperMethods';
import { PricingSimulatorNotificationMessages } from 'utils/Enums';

interface Props {
    refetchScenarioTableData: Function;
    setDimensionCheckboxObj: Function;
}

interface outputType {
    loading: boolean;
    mutate: UseMutateFunction<AxiosResponse<any, any> | undefined, Error, any, unknown>;
}

function useUpdateDelistOrCompFollowStatus({ refetchScenarioTableData, setDimensionCheckboxObj }: Props): outputType {
    // Queries
    const { isPending, isPaused, mutate } = useMutation({
        mutationFn: async (inputData: any) => {
            //write onsuccess and onerror where mutate function is called
            try {
                const url = pricingSimulatorUrls.updateDelistOrCompFollowStatusUrl;

                const data = await axios({
                    method: 'post',
                    url,
                    data: { ...inputData },
                });
                return data;
            } catch (error) {
                console.log('err ', error);
                throw error;
            }
        },
        onSuccess: (_, variables) => {
            setDimensionCheckboxObj({});
            refetchScenarioTableData();
        },
        onError: (error) => {},
    });
    const apiLoading = isPaused || isPending;

    const outputData: outputType = {
        loading: apiLoading,
        mutate,
    };
    return outputData;
}

export default useUpdateDelistOrCompFollowStatus;
